import { render, staticRenderFns } from "./td-ClientTrade.vue?vue&type=template&id=441af63c&"
import script from "./td-ClientTrade.vue?vue&type=script&lang=js&"
export * from "./td-ClientTrade.vue?vue&type=script&lang=js&"
import style0 from "./td-ClientTrade.vue?vue&type=style&index=0&id=441af63c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports